export function steps(t: any) {
  return [
    { icon: t("steps.0.icon"), text: t("steps.0.text") },
    { icon: t("steps.1.icon"), text: t("steps.1.text") },
    { icon: t("steps.2.icon"), text: t("steps.2.text") },
    { icon: t("steps.3.icon"), text: t("steps.3.text") },
  ];
}

export function PassengerStepLiteralsPage(t: any) {
  return {
    page: {
      title: t("passengerStepLiteralsPage.page.title"),
      saveButton: t("passengerStepLiteralsPage.page.saveButton"),
      buttonBack: t("passengerStepLiteralsPage.page.buttonBack"),
    },
    accordion: {
      passenger: t("passengerStepLiteralsPage.accordion.passenger"),
      adultLiteral: t("passengerStepLiteralsPage.accordion.adultLiteral"),
      childLiteral: t("passengerStepLiteralsPage.accordion.childLiteral"),
      babyLiteral: t("passengerStepLiteralsPage.accordion.babyLiteral"),
    },
    personalData: {
      title: t("passengerStepLiteralsPage.personalData.title"),
      subtitle: t("passengerStepLiteralsPage.personalData.subtitle"),
      birthdaytitle: t("passengerStepLiteralsPage.personalData.birthdaytitle"),
      babyTitle: t("passengerStepLiteralsPage.personalData.babyTitle"),
      form: {
        formErrors: {
          required: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.required"
          ),
          name: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.name"
          ),
          surname: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.surname"
          ),
          surname2: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.surname2"
          ),
          day: t("passengerStepLiteralsPage.personalData.form.formErrors.day"),
          month: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.month"
          ),
          year: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.year"
          ),
          prefixNumber: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.prefixNumber"
          ),
          phoneNumber: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.phoneNumber"
          ),
          email: t(
            "passengerStepLiteralsPage.personalData.form.formErrors.email"
          ),
        },
        email: {
          label: t("passengerStepLiteralsPage.personalData.form.email.label"),
        },
        name: {
          label: t("passengerStepLiteralsPage.personalData.form.name.label"),
        },
        surname: {
          label: t("passengerStepLiteralsPage.personalData.form.surname.label"),
        },
        surname2: {
          label: t(
            "passengerStepLiteralsPage.personalData.form.surname2.label"
          ),
        },
        prefix: {
          label: t("passengerStepLiteralsPage.personalData.form.prefix.label"),
        },
        phone: {
          label: t("passengerStepLiteralsPage.personalData.form.phone.label"),
        },
        day: {
          label: t("passengerStepLiteralsPage.personalData.form.day.label"),
        },
        month: {
          label: t("passengerStepLiteralsPage.personalData.form.month.label"),
        },
        year: {
          label: t("passengerStepLiteralsPage.personalData.form.year.label"),
        },
        associatedAdult: {
          label: t(
            "passengerStepLiteralsPage.personalData.form.associatedAdult.label"
          ),
        },
      },
    },
    documentSection: {
      title: t("passengerStepLiteralsPage.documentSection.title"),
      subtitle: t("passengerStepLiteralsPage.documentSection.subtitle"),
      documentType: {
        requiredError: t(
          "passengerStepLiteralsPage.documentSection.documentType.requiredError"
        ),
        dni: {
          title: t(
            "passengerStepLiteralsPage.documentSection.documentType.dni.title"
          ),
          subtitle: t(
            "passengerStepLiteralsPage.documentSection.documentType.dni.subtitle"
          ),
          errormsg: t(
            "passengerStepLiteralsPage.documentSection.documentType.dni.errormsg"
          ),
        },
        nie: {
          title: t(
            "passengerStepLiteralsPage.documentSection.documentType.nie.title"
          ),
          subtitle: t(
            "passengerStepLiteralsPage.documentSection.documentType.nie.subtitle"
          ),
          errormsg: t(
            "passengerStepLiteralsPage.documentSection.documentType.nie.errormsg"
          ),
        },
        passport: {
          title: t(
            "passengerStepLiteralsPage.documentSection.documentType.passport.title"
          ),
          subtitle: t(
            "passengerStepLiteralsPage.documentSection.documentType.passport.subtitle"
          ),
          errormsg: t(
            "passengerStepLiteralsPage.documentSection.documentType.passport.errormsg"
          ),
        },
      },
      slotNames: {
        slot1: t("passengerStepLiteralsPage.documentSection.slotNames.slot1"),
        slot2: t("passengerStepLiteralsPage.documentSection.slotNames.slot2"),
        slot3: t("passengerStepLiteralsPage.documentSection.slotNames.slot3"),
      },
      label: t("passengerStepLiteralsPage.documentSection.label"),
    },
    discountSection: {
      titleSection: t("passengerStepLiteralsPage.discountSection.titleSection"),
      warningMessage: t(
        "passengerStepLiteralsPage.discountSection.warningMessage"
      ),
      pointSectionCard: {
        title: t(
          "passengerStepLiteralsPage.discountSection.pointSectionCard.title"
        ),
        description: t(
          "passengerStepLiteralsPage.discountSection.pointSectionCard.description"
        ),
        formLabel: t(
          "passengerStepLiteralsPage.discountSection.pointSectionCard.formLabel"
        ),
        errorFormMessage: t(
          "passengerStepLiteralsPage.discountSection.pointSectionCard.errorFormMessage"
        ),
      },
      familySectionCard: {
        title: t(
          "passengerStepLiteralsPage.discountSection.familySectionCard.title"
        ),
        description: t(
          "passengerStepLiteralsPage.discountSection.familySectionCard.description"
        ),
        generalCard: {
          title: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.generalCard.title"
          ),
          description: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.generalCard.description"
          ),
        },
        specialCard: {
          title: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.specialCard.title"
          ),
          description: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.specialCard.description"
          ),
        },
        familyCardSelectedSection: {
          generalText: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.familyCardSelectedSection.generalText"
          ),
          specialText: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.familyCardSelectedSection.specialText"
          ),
          button: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.familyCardSelectedSection.button"
          ),
        },
        form: {
          confirmButtonText: t(
            "passengerStepLiteralsPage.discountSection.familySectionCard.form.confirmButtonText"
          ),
          formErrors: {
            required: t(
              "passengerStepLiteralsPage.discountSection.familySectionCard.form.formErrors.required"
            ),
            errorFormMessage: t(
              "passengerStepLiteralsPage.discountSection.familySectionCard.form.formErrors.errorFormMessage"
            ),
          },
          licenseNumber: {
            label: t(
              "passengerStepLiteralsPage.discountSection.familySectionCard.form.licenseNumber.label"
            ),
          },
          autonomousCommunity: {
            label: t(
              "passengerStepLiteralsPage.discountSection.familySectionCard.form.autonomousCommunity.label"
            ),
          },
        },
      },
      cardDiscountSection: {
        title: t(
          "passengerStepLiteralsPage.discountSection.cardDiscountSection.title"
        ),
        description: t(
          "passengerStepLiteralsPage.discountSection.cardDiscountSection.description"
        ),
        discountCardSection: {
          departure: {
            titleSection: {
              title: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.titleSection.title"
              ),
              aveId: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.titleSection.aveId"
              ),
              location: [
                t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.titleSection.location.0"
                ),
                t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.titleSection.location.1"
                ),
              ],
            },
            cardsSection: {
              title: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.title"
              ),
              discountCardsList: [
                {
                  title: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.0.title"
                  ),
                  description: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.0.description"
                  ),
                  discount: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.0.discount"
                  ),
                  id: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.0.id"
                  ),
                },
                {
                  title: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.1.title"
                  ),
                  description: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.1.description"
                  ),
                  discount: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.1.discount"
                  ),
                  id: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.1.id"
                  ),
                },
                {
                  title: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.2.title"
                  ),
                  description: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.2.description"
                  ),
                  discount: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.2.discount"
                  ),
                  id: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.2.id"
                  ),
                },
              ],
            },
          },
          return: {
            titleSection: {
              title: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.titleSection.title"
              ),
              aveId: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.titleSection.aveId"
              ),
              location: [
                t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.titleSection.location.0"
                ),
                t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.titleSection.location.1"
                ),
              ],
            },
            cardsSection: {
              title: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.title"
              ),
              discountCardsList: [
                {
                  title: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.0.title"
                  ),
                  description: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.0.description"
                  ),
                  discount: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.0.discount"
                  ),
                  id: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.0.id"
                  ),
                },
                {
                  title: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.1.title"
                  ),
                  description: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.1.description"
                  ),
                  discount: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.1.discount"
                  ),
                  id: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.1.id"
                  ),
                },
                {
                  title: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.2.title"
                  ),
                  description: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.2.description"
                  ),
                  discount: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.2.discount"
                  ),
                  id: t(
                    "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.return.cardsSection.discountCardsList.2.id"
                  ),
                },
              ],
            },
          },
          successToastSection: {
            titlePart1: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.successToastSection.titlePart1"
            ),
            titlePart2: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.successToastSection.titlePart2"
            ),
            editButton: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.successToastSection.editButton"
            ),
          },
          formSection: {
            title: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.formSection.title"
            ),
            form: {
              seeReturButton: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.formSection.form.seeReturButton"
              ),
              confirmButton: t(
                "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.formSection.form.confirmButton"
              ),
              formErrors: {
                required: t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.formSection.form.formErrors.required"
                ),
                errorFormMessage: t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.formSection.form.formErrors.errorFormMessage"
                ),
              },
              cardNumerInput: {
                label: t(
                  "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.formSection.form.cardNumerInput.label"
                ),
              },
            },
          },
          footerSection: {
            switchTitle: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.footerSection.switchTitle"
            ),
            confirmButtonText: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.footerSection.confirmButtonText"
            ),
            seeReturnSectionButton: t(
              "passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.footerSection.seeReturnSectionButton"
            ),
          },
          emptyStateSection: {
            noDiscountTripTitle: t('passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.emptyStateSection.noDiscountTripTitle'),
          }
        },
      },
    },
  };
}

export function discountCardsMockList(t: any) {
  return {
    title: t("discountCardsMockList.title"),
    discountCardsList: [
      {
        title: t("discountCardsMockList.discountCardsList.0.title"),
        description: t("discountCardsMockList.discountCardsList.0.description"),
        discount: t("discountCardsMockList.discountCardsList.0.discount"),
        id: t("discountCardsMockList.discountCardsList.0.id"),
      },
      {
        title: t("discountCardsMockList.discountCardsList.1.title"),
        description: t("discountCardsMockList.discountCardsList.1.description"),
        discount: t("discountCardsMockList.discountCardsList.1.discount"),
        id: t("discountCardsMockList.discountCardsList.1.id"),
      },
      {
        title: t("discountCardsMockList.discountCardsList.2.title"),
        description: t("discountCardsMockList.discountCardsList.2.description"),
        discount: t("discountCardsMockList.discountCardsList.2.discount"),
        id: t("discountCardsMockList.discountCardsList.2.id"),
      },
    ],
  };
}

export function SeatingPageliterals(t: any) {
  return {
    title: t("seatingPageliterals.title"),
    confirmButtonText: t("seatingPageliterals.confirmButtonText"),
    seeReturnSectionButton: t("seatingPageliterals.seeReturnSectionButton"),
    seeDeparture: t("seatingPageliterals.seeDeparture"),
    avePlannerLiterals: {
      car: t("seatingPageliterals.avePlannerLiterals.car"),
      seat: t("seatingPageliterals.avePlannerLiterals.seat"),
      available: t("seatingPageliterals.avePlannerLiterals.available"),
      notAvailable: t("seatingPageliterals.avePlannerLiterals.notAvailable"),
      yourSelect: t("seatingPageliterals.avePlannerLiterals.yourSelect"),
      confirButton: t("seatingPageliterals.avePlannerLiterals.confirButton"),
      total: t("seatingPageliterals.avePlannerLiterals.total"),
    },
    seatingNotSelectedAllModal: {
      title: t("seatingPageliterals.seatingNotSelectedAllModal.title"),
      desc: t("seatingPageliterals.seatingNotSelectedAllModal.desc"),
      cancelbutton: t("seatingPageliterals.seatingNotSelectedAllModal.cancelbutton"),
      okbutton: t("seatingPageliterals.seatingNotSelectedAllModal.okbutton"),
    }
  };
}

export function SeatingCardsList(t: any) {
  return [
    {
      title: t("seatingCardsList.0.title"),
      description: t("seatingCardsList.0.description"),
      priceText: t("seatingCardsList.0.priceText"),
      price: t("seatingCardsList.0.price"),
      id: t("seatingCardsList.0.id"),
    },
    {
      title: t("seatingCardsList.1.title"),
      description: t("seatingCardsList.1.description"),
      priceText: t("seatingCardsList.1.priceText"),
      price: t("seatingCardsList.1.price"),
      id: t("seatingCardsList.1.id"),
    },
    {
      title: t("seatingCardsList.2.title"),
      description: t("seatingCardsList.2.description"),
      priceText: t("seatingCardsList.2.priceText"),
      price: t("seatingCardsList.2.price"),
      id: t("seatingCardsList.2.id"),
    },
  ];
}

export function SummaryAveLiterals(t: any) {
  return {
    titleTopSection: t("summaryAveLiterals.titleTopSection"),
    trainTotalTicketTitle: t("summaryAveLiterals.trainTotalTicketTitle"),
    totalTripTitle: t("summaryAveLiterals.totalTripTitle"),
    aproxLiteral: t("summaryAveLiterals.aproxLiteral"),
    tripWithReturnLiteral: t("summaryAveLiterals.tripWithReturnLiteral"),
    showMore: t("summaryAveLiterals.showMore"),
    showLess: t("summaryAveLiterals.showLess"),
    departureText: t("summaryAveLiterals.departureText"),
    returnText: t("summaryAveLiterals.returnText"),
  };
}

export function extrasCardsMockList(t: any) {
  return [
    {
      codComplement: t("extrasCardsMockList.0.codComplement"),
      nameComplement: t("extrasCardsMockList.0.nameComplement"),
      descComplement: t("extrasCardsMockList.0.descComplement"),
      numMaxSelection: t("extrasCardsMockList.0.numMaxSelection"),
      asignationType: t("extrasCardsMockList.0.asignationType"),
      price: t("extrasCardsMockList.0.price"),
    },
    {
      codComplement: t("extrasCardsMockList.1.codComplement"),
      nameComplement: t("extrasCardsMockList.1.nameComplement"),
      descComplement: t("extrasCardsMockList.1.descComplement"),
      numMaxSelection: t("extrasCardsMockList.1.numMaxSelection"),
      asignationType: t("extrasCardsMockList.1.asignationType"),
      price: t("extrasCardsMockList.1.price"),
    },
    {
      codComplement: t("extrasCardsMockList.2.codComplement"),
      nameComplement: t("extrasCardsMockList.2.nameComplement"),
      descComplement: t("extrasCardsMockList.2.descComplement"),
      numMaxSelection: t("extrasCardsMockList.2.numMaxSelection"),
      asignationType: t("extrasCardsMockList.2.asignationType"),
      price: t("extrasCardsMockList.2.price"),
    },
  ];
}

export function ExtrasPageLiterals(t: any) {
  return {
    extrasPage: {
      title: t("extrasPageLiterals.extrasPage.title"),
      confirmButtonText: t("extrasPageLiterals.extrasPage.confirmButtonText"),
      seeReturnSectionButton: t(
        "extrasPageLiterals.extrasPage.seeReturnSectionButton"
      ),
      seeDeparture: t("extrasPageLiterals.extrasPage.seeDeparture"),
      continueWithoutExtras: t(
        "extrasPageLiterals.extrasPage.continueWithoutExtras"
      ),
    },
    molExtras: {
      title: t("extrasPageLiterals.molExtras.title"),
      confirmButtonText: t("extrasPageLiterals.molExtras.confirmButtonText"),
      seeReturnSectionButton: t(
        "extrasPageLiterals.molExtras.seeReturnSectionButton"
      ),
      seeDeparture: t("extrasPageLiterals.molExtras.seeDeparture"),
      continueWithoutExtras: t(
        "extrasPageLiterals.molExtras.continueWithoutExtras"
      ),
      perPerson: t("extrasPageLiterals.molExtras.perPerson"),
      total: t("extrasPageLiterals.molExtras.total"),
      free: t("extrasPageLiterals.molExtras.free"),
      howManyPassengers: t("extrasPageLiterals.molExtras.howManyPassengers"),
      addToAll: t("extrasPageLiterals.molExtras.addToAll"),
      confirmBy: t("extrasPageLiterals.molExtras.confirmBy"),
      saveWithSuperflex: t("extrasPageLiterals.molExtras.saveWithSuperflex"),
      noExtrasTripTitle: t("extrasPageLiterals.molExtras.noExtrasTripTitle"),
      noExtrasTripDesc: t("extrasPageLiterals.molExtras.noExtrasTripDesc"),
      modalAskSuperflex: {
        title: t("extrasPageLiterals.molExtras.modalAskSuperflex.title"),
        desc: t("extrasPageLiterals.molExtras.modalAskSuperflex.desc"),
        listExtras: [
          t("extrasPageLiterals.molExtras.modalAskSuperflex.listExtras.0"),
          t("extrasPageLiterals.molExtras.modalAskSuperflex.listExtras.1"),
          t("extrasPageLiterals.molExtras.modalAskSuperflex.listExtras.2")
        ],
        cancelbutton: t("extrasPageLiterals.molExtras.modalAskSuperflex.cancelbutton"),
        okbutton: t("extrasPageLiterals.molExtras.modalAskSuperflex.okbutton")
      },
      modalAskDelete: {
        title: t("extrasPageLiterals.molExtras.modalAskDelete.title"),
        desc: t("extrasPageLiterals.molExtras.modalAskDelete.desc"),
        cancelbutton: t("extrasPageLiterals.molExtras.modalAskDelete.cancelbutton"),
        okbutton: t("extrasPageLiterals.molExtras.modalAskDelete.okbutton")
      },
      modalUnsavedData: {
        title: t("extrasPageLiterals.molExtras.modalUnsavedData.title"),
        desc: t("extrasPageLiterals.molExtras.modalUnsavedData.desc"),
        cancelbutton: t("extrasPageLiterals.molExtras.modalUnsavedData.cancelbutton"),
        okbutton: t("extrasPageLiterals.molExtras.modalUnsavedData.okbutton")
      }
    },
    startExtrasPage: {
      title: t("extrasPageLiterals.startExtrasPage.title"),
      desc: t("extrasPageLiterals.startExtrasPage.desc"),
      security: t("extrasPageLiterals.startExtrasPage.security"),
      suitcase: t("extrasPageLiterals.startExtrasPage.suitcase"),
      pets: t("extrasPageLiterals.startExtrasPage.pets"),
      restaurant: t("extrasPageLiterals.startExtrasPage.restaurant"),
      seat: t("extrasPageLiterals.startExtrasPage.seat"),
      continueWithoutExtras: t(
        "extrasPageLiterals.startExtrasPage.continueWithoutExtras"
      ),
      addExtras: t("extrasPageLiterals.startExtrasPage.addExtras"),
    },
    extrasCardsList: [
      {
        codComplement: t("extrasPageLiterals.extrasCardsList.0.codComplement"),
        nameComplement: t("extrasPageLiterals.extrasCardsList.0.nameComplement"),
        descComplement: t("extrasPageLiterals.extrasCardsList.0.descComplement"),
        numMaxSelection: t("extrasPageLiterals.extrasCardsList.0.numMaxSelection"),
        asignationType: t("extrasPageLiterals.extrasCardsList.0.asignationType"),
        price: t("extrasPageLiterals.extrasCardsList.0.price"),
      },
      {
        codComplement: t("extrasPageLiterals.extrasCardsList.1.codComplement"),
        nameComplement: t("extrasPageLiterals.extrasCardsList.1.nameComplement"),
        descComplement: t("extrasPageLiterals.extrasCardsList.1.descComplement"),
        numMaxSelection: t("extrasPageLiterals.extrasCardsList.1.numMaxSelection"),
        asignationType: t("extrasPageLiterals.extrasCardsList.1.asignationType"),
        price: t("extrasPageLiterals.extrasCardsList.1.price"),
      },
      {
        codComplement: t("extrasPageLiterals.extrasCardsList.2.codComplement"),
        nameComplement: t("extrasPageLiterals.extrasCardsList.2.nameComplement"),
        descComplement: t("extrasPageLiterals.extrasCardsList.2.descComplement"),
        numMaxSelection: t("extrasPageLiterals.extrasCardsList.2.numMaxSelection"),
        asignationType: t("extrasPageLiterals.extrasCardsList.2.asignationType"),
        price: t("extrasPageLiterals.extrasCardsList.2.price"),
      },
      {
        codComplement: t("extrasPageLiterals.extrasCardsList.3.codComplement"),
        nameComplement: t("extrasPageLiterals.extrasCardsList.3.nameComplement"),
        descComplement: t("extrasPageLiterals.extrasCardsList.3.descComplement"),
        numMaxSelection: t("extrasPageLiterals.extrasCardsList.3.numMaxSelection"),
        asignationType: t("extrasPageLiterals.extrasCardsList.3.asignationType"),
        price: t("extrasPageLiterals.extrasCardsList.3.price"),
      },
      {
        codComplement: t("extrasPageLiterals.extrasCardsList.4.codComplement"),
        nameComplement: t("extrasPageLiterals.extrasCardsList.4.nameComplement"),
        descComplement: t("extrasPageLiterals.extrasCardsList.4.descComplement"),
        url: t("extrasPageLiterals.extrasCardsList.4.url"),
        numMaxSelection: t("extrasPageLiterals.extrasCardsList.4.numMaxSelection"),
        asignationType: t("extrasPageLiterals.extrasCardsList.4.asignationType"),
        price: t("extrasPageLiterals.extrasCardsList.4.price"),
      }
    ],
  };
}

export function resumeLiteralsPage(t: any) {
  return {
    page: {
      title: t("resumeLiteralsPage.page.title"),
      departureTitle: t("resumeLiteralsPage.page.departureTitle"),
      returnTitle: t("resumeLiteralsPage.page.returnTitle"),
      confirmButton: t("resumeLiteralsPage.page.confirmButton"),
    },
    resumeMoleculeLiterals: {
      discountTitle: t(
        "resumeLiteralsPage.resumeMoleculeLiterals.discountTitle"
      ),
      extrasTitle: t("resumeLiteralsPage.resumeMoleculeLiterals.extrasTitle"),
    },
  };
}

export function EmptyDiscountState(t: any) {
  return {
    id: t("emptyDiscountState.id"),
    name: t("emptyDiscountState.name"),
    ammount: t("emptyDiscountState.ammount"),
  };
}

export function EmptyExtrasState(t: any) {
  return {
    id: t("emptyExtrasState.id"),
    name: t("emptyExtrasState.name"),
    ammount: t("emptyExtrasState.ammount"),
  };
}

export function generalFamilyCard(t: any) {
  return {
    id: t("generalFamilyCard.id"),
    title: t("generalFamilyCard.title"),
    description: t("generalFamilyCard.description"),
    percentageDiscount: t("generalFamilyCard.percentageDiscount"),
    discountAllTrainForPerson: t("generalFamilyCard.discountAllTrainForPerson"),
  };
}

export function specialFamilyCard(t: any) {
  return {
    id: t("specialFamilyCard.id"),
    title: t("specialFamilyCard.title"),
    description: t("specialFamilyCard.description"),
    percentageDiscount: t("specialFamilyCard.percentageDiscount"),
    discountAllTrainForPerson: t("specialFamilyCard.discountAllTrainForPerson"),
  };
}

export function passengerTypeLiterals(t: any) {
  return {
    ADULT: t("passengerTypeLiterals.ADULT"),
    CHILD: t("passengerTypeLiterals.CHILD"),
    BABY: t("passengerTypeLiterals.BABY"),
  };
}


export function getFooterLiterals(t: any) {
  return {
    title: t("getFooterLiterals.title"),
    showPrivacyPolicyText: t("getFooterLiterals.showPrivacyPolicyText"),
    showLegalConditionsText: t("getFooterLiterals.showLegalConditionsText"),
    showCookiePolicyText: t("getFooterLiterals.showCookiePolicyText"),
    linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
    linkLegalConditionsText: "https://www.docomobility.com/es/terminos-y-condiciones",
    linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
  };
}

export function getSilentCarLiterals(t: any) {
  return {
    title: t("getSilentCarLiterals.title"),
    generalRules: {
      title: t("getSilentCarLiterals.generalRules.title"),
      rules: [
        t("getSilentCarLiterals.generalRules.rules.0"),
        t("getSilentCarLiterals.generalRules.rules.1"),
        t("getSilentCarLiterals.generalRules.rules.2"),
        t("getSilentCarLiterals.generalRules.rules.3")
      ],
    },
    rulesSilentCard: {
      title: t("getSilentCarLiterals.rulesSilentCard.title"),
      rules: [
        t("getSilentCarLiterals.rulesSilentCard.rules.0"),
        t("getSilentCarLiterals.rulesSilentCard.rules.1"),
        t("getSilentCarLiterals.rulesSilentCard.rules.2"),
        t("getSilentCarLiterals.rulesSilentCard.rules.3")
      ]
    },
    otherTicket: t("getSilentCarLiterals.otherTicket"),
    okButton: t("getSilentCarLiterals.okButton")
  }
}

export function getDiscountsLiterals(t: any) {
  return {
    discountCardsList: [
      {
        title: t("passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.0.title"),
        id: "JOVEN"
      },
      {
        title: t("passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.1.title"),
        id: "MASRENFE"
      }, {
        title: t("passengerStepLiteralsPage.discountSection.cardDiscountSection.discountCardSection.departure.cardsSection.discountCardsList.2.title"),
        id: "DORADA"
      },
    ],
  }
}

export function sessionLanguageMapping() {
  let lenguage = "";

  if (sessionStorage.getItem('raas-language') == 'en') {
    lenguage = 'en-GB';
    //Para el valenciano se pone el catalan
  } else if (sessionStorage.getItem('raas-language') == 'va') {
    lenguage = 'ca';
  } else {
    lenguage = sessionStorage.getItem('raas-language') || "es";
  }
  return lenguage;
}
export function literalExtrasConverter(id:string,t:any,value?:string) {
  let result=""
  switch (id) {
    case 'ANUL':
        result=t("extrasCardsMockList.0.nameComplement")
      break;
      case 'SUIT':
        result=t("extrasCardsMockList.1.nameComplement")
      break;
      case 'PETS':
        result=t("extrasCardsMockList.2.nameComplement")
      break;
      case 'SEAT':
        result=t("literals.seatSelection")
      break
      case 'CHOISE_INDIFERENT':
        result=t("seatingCardsList.0.title")
      break
      case 'CHOISE_WINDOW':
        result=t("seatingCardsList.1.title")
      break
      case 'CHOISE_HALLWAY':
        result=t("seatingCardsList.2.title")
      break
      case 'LARGE_FAMILY_CARD':
        if(value?.includes('GENERAL')){
          result=t("literals.generalTextDiscount")
        }else{
          result=t("literals.specialTextDiscount")
        }
      break
  
    default:
      result=t("literals.noMacthExtra")
      break;
  }

  return result
}

export function pricesConverter(price:string) {
  let priceNumber = price.match(/(\d+(,\d{1,2})?)/g);
  return priceNumber ? parseFloat(priceNumber[0].replace(',','.')) : 0;
}


export function deleteDuplicateArray(array:any) {
  const newArray: any[] = [];
  array.forEach((obj: { name: any; }) => {
    if (!newArray.some(o => o.name === obj.name)) {
      newArray.push({ ...obj })
    }
  });
return newArray
}
